/**
 * Global Namespace
 * @description window.__NDE__ 전역 네임스페이스 초기화
 *
 * 각 모듈 엔트리에서 import 하여 window.__NDE__.ModuleName 형태로 등록합니다.
 * 이미 존재하면 기존 객체를 재사용합니다.
 */

export type NDENamespace = Record<string, unknown>;

declare global {
  interface Window {
    __NDE__: NDENamespace;
  }
}

if (!window.__NDE__) {
  window.__NDE__ = {};
}

export const NDE = window.__NDE__;
